<template>
  <div class="award-text">
    <div class="main">
      <i class="fas fa-award"></i>
      {{content.description}}
    </div>
    <div class="result">>>> {{content.get}}</div>
  </div>
</template>

<script>
export default {
  props: {
    awards: {
      type: Object,
      default: () => ({
        description: '2019 生醫產業與新農業 創新創業競賽',
        get: '新農業組 金獎',
      }),
    },
  },
  data() {
    return {
      content: this.awards,
    };
  },
  components: {},
};
</script>

<style scoped lang="scss">
.award-text {
  font-size: 1.1rem;
  margin-bottom: 50px;
  .fas {
    color: #ad0202;
    font-size: 1.5rem;
    padding-right: 30px;
  }
  .main {
    // color: deepskyblue;
    color: #2685B3;
    margin-bottom: 20px;
  }
  .result {
    padding-left: 50px;
    color: dimgray;
  }
}

@media screen and (max-width: 600px){
  .award-text {
    .fas {
      padding-right: 15px;
    }
    .result {
      padding-left: 35px;
    }
  }
}
</style>
